import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import FormLayout from '../../../../../components/Form/FormLayout'
import CampaignHeaderSteps from '../components/CampaignForms/CampaignHeaderSteps/CampaignHeaderSteps'
import CampaignHeaderStep from '../components/CampaignForms/CampaignHeaderSteps/CampaignHeaderStep'
import DetailsInfoBtns from '../../../../../components/UI/DetailsInfoBtns'
import routes from '../../../../../constants/routes'
import CampaignDetailsStep from '../components/CampaignForms/CampaignFormSteps/CampaignDetailsStep'
import EmailTemplatePreviewImage from '../../../../Director/components/UI/EmailTemplatePreviewImage'
import { useNewsletters } from '../../../../../context/NewsletterCtx/NewslettersProvider'
import validationSchema from '../../../../../utils/validationSchema'
import MailingListModal from '../components/MailingList/MailingListModal'
import { useMailingList } from '../../../../../context/MailingListCtx/MailingListProvider'
import SelectedClientsModal from '../components/MailingList/SelectedClientsModal'
import ConfirmationModal from '../../../../../components/Modals/ConfirmationModal'
import apiService from '../../../../../services/api/apiService'
import SpecificClientsListModal from '../components/MailingList/SpecificClientsListModal'
import UserMethods from '../../../../../utils/userMethods'

function CampaignDetails() {
  const authUser = UserMethods.getUser()
  const navigate = useNavigate()
  const newslettersCtx = useNewsletters()
  const mailingListCtx = useMailingList()
  const nextStepPath = authUser?.user.user_type === 'DIRECTOR' ? routes.director.designEmail : routes.agent.designEmail

  const formik = useFormik({
    initialValues: {
      campaignName: newslettersCtx.getter.campaignName ?? '',
      emailSubject: newslettersCtx.getter.emailSubject ?? '',
      mailingList: mailingListCtx.getter.selectedMailingListInput ?? '',
      chooseSomeReceivers: ''
    },
    validationSchema: () => validationSchema
      .campaignDetailsForm(mailingListCtx.getter.specificMailingListClients),
    onSubmit: (values) => {
      newslettersCtx.setter.setCampaignName(values.campaignName)
      newslettersCtx.setter.setEmailSubject(values.emailSubject)
      mailingListCtx.setter.setSelectedMailingListInput(values.mailingList)
      navigate(nextStepPath, {
        state: {
          isCampaignDetailsCompleted: true
        }
      })
    }
  })

  const [t] = useTranslation()
  useEffect(() => {
    document.title = `Demo CRM - ${t('campaignDetails')}`
  }, [t])
  return (
    <>
      <ConfirmationModal cacheKey="mailingList" toastSuccessMessage="mailingHasBeenDeleted" mutationFn={apiService.deleteMailingList} />
      <div className="flex gap-[40px] flex-col-reverse 3xl:grid 3xl:grid-cols-2">
        <div className="flex flex-col">
          <FormLayout marginBottom="mb-0">
            <CampaignHeaderSteps>
              <CampaignHeaderStep status="inProgress" text="campaignDetails" stepNumber={1} />
              <CampaignHeaderStep status="inActive" text="emailDesign" stepNumber={2} />
              <CampaignHeaderStep status="inActive" text="preview" stepNumber={3} />
            </CampaignHeaderSteps>
            <CampaignDetailsStep formik={formik} />
          </FormLayout>
          <DetailsInfoBtns
            type="submit"
            btnText="nextStep"
            onClickHandler={
            () => formik.submitForm()
              }
          />
        </div>
        <FormLayout marginBottom="mb-0">
          <EmailTemplatePreviewImage />
        </FormLayout>
      </div>
      {/* MODALS */}
      <MailingListModal mailingListId={formik.values.mailingList} />
      <SpecificClientsListModal />

      <SelectedClientsModal
        closeModal={mailingListCtx.closeSelectedClientsModalHandler}
        showModal={mailingListCtx.showSelectedClientsModal}
        selectedClients={mailingListCtx.getter.mailingListSelectedClients}
        onRemoveClient={mailingListCtx.onRemoveClientHandler}
        onClearSelectedClients={mailingListCtx.onClearMailingListSelectedClientsHandler}
      />
      <SelectedClientsModal
        closeModal={mailingListCtx.closeSelectedSpecificClientsModalHandler}
        showModal={mailingListCtx.showSelectedSpecificClientsModal}
        selectedClients={mailingListCtx.getter.specificMailingListClients}
        onRemoveClient={mailingListCtx.onRemoveSpecificClientHandler}
        onClearSelectedClients={mailingListCtx.onClearSpecificClientsHandler}
      />
    </>

  )
}

export default CampaignDetails
